import { useEffect, useState } from "react";
import MenuDashboard from "../../../components/MenuDashboard";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import { ptBR } from "date-fns/locale";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { getNotificacaoCliente } from "../../../api/Notificacao";
import { formatDistance, formatDistanceToNow } from "date-fns";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { useAuth } from "../../../hooks/AuthContext";
import useStyles from "./styles";
import {
  Box,
  Button,
  Pagination,
  Popover,
  Skeleton,
  Chip,
  Card,
  useTheme,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import { ButtonAcaoGrande, Subtitulo } from "../../../components";
import useAlert from "../../../hooks/useAlert";
import { useQuery } from "react-query";
import useNotificationNaoLida from "../../../hooks/useNotifications/useNotificationsNaoLida";
import useNotificationLidas from "../../../hooks/useNotifications/useNotificationsLidas";

export function Notificacoes() {
  const { showAlertError } = useAlert();
  const classes = useStyles();
  const theme = useTheme();

  const {
    refetchNotificacoesNaoLidas,
    notificacoesNaoLidas,
    setMarcarComoLida,
    handlerNextPageNaoLidas,
    hasNextPageNaoLidas,
    isLoadingNotNaoLida,
    errorNotNaoLida,
    setTodasComoLida,
  } = useNotificationNaoLida();

  const {
    notificacoesLida,
    refetchNotificacoesLidas,
    handlerNextPageLidas,
    hasNextPageLidas,
    isLoadingNotLida,
    errorNotLida,
  } = useNotificationLidas();

  const [isLoading, setIsLoading] = useState(false);
  const [notificacoes, setNotificacoes] = useState(null);
  const [isLido, setIsLido] = useState(false);

  const configuraNotificacao = (lido) => {
    if (lido) {
      setNotificacoes(notificacoesLida);
      return;
    }

    if (!lido) {
      setNotificacoes(notificacoesNaoLidas);
      return;
    }
  };

  useEffect(() => {
    refetchNotificacoesNaoLidas();
  }, []);

  useEffect(() => {
    if (errorNotLida) {
      showAlertError(`Ops, algo deu errado :  ${errorNotLida}`);
      return;
    }

    if (errorNotNaoLida) {
      showAlertError(`Ops, algo deu errado :  ${errorNotNaoLida}`);
      return;
    }
  }, [errorNotNaoLida, errorNotLida]);

  useEffect(() => {
    configuraNotificacao(false);
  }, [notificacoesNaoLidas]);

  useEffect(() => {
    configuraNotificacao(true);
  }, [notificacoesLida]);

  const handlerChangeLido = (event, newValue) => {
    if (newValue !== null) {
      setIsLido(newValue);
    }
  };

  useEffect(() => {
    if (isLido) {
      refetchNotificacoesLidas();
      configuraNotificacao(isLido);
      return;
    }

    refetchNotificacoesNaoLidas();
    configuraNotificacao(isLido);
  }, [isLido]);

  const handlerCarregarMais = () => {
    setIsLoading(true);
    if (isLido) {
      handlerNextPageLidas();
      refetchNotificacoesLidas();

      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
      return;
    }

    handlerNextPageNaoLidas();
    refetchNotificacoesNaoLidas();

    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  const handleMarkAsRead = (notificacao) => {
    if (!isLido) {
      setMarcarComoLida(notificacao.id);
    }
  };

  return (
    <MenuDashboard pagina>
      <Box sx={{ p: { xs: 2, md: 3 } }}>
        <Card
          sx={{
            borderRadius: 3,
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
            overflow: "hidden",
          }}
        >
          {/* Cabeçalho */}
          <Box
            sx={{
              p: 3,
              borderBottom: `1px solid ${theme.palette.divider}`,
              backgroundColor: theme.palette.grey[50],
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <NotificationsActiveIcon
                sx={{
                  fontSize: 32,
                  color: theme.palette.primary.main,
                  mr: 2,
                }}
              />
              <Typography variant="h5" fontWeight="600">
                Notificações
              </Typography>
            </Box>

            <ToggleButtonGroup
              value={isLido}
              exclusive
              onChange={handlerChangeLido}
              aria-label="status notificação"
              sx={{ width: "100%" }}
            >
              <ToggleButton
                value={false}
                sx={{
                  flex: 1,
                  py: 1.5,
                  textTransform: "none",
                  fontWeight: 600,
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: isLido
                    ? "transparent"
                    : theme.palette.primary.main,
                  backgroundColor: theme.palette.action.hover,
                  color: isLido ? theme.palette.text.secondary : "white",
                 
                }}
              >
                <NotificationsActiveIcon sx={{ mr: 1, fontSize: 20 }} />
                Não lidas
                {notificacoesNaoLidas?.length > 0 && (
                  <Chip
                    label={notificacoesNaoLidas.length}
                    size="small"
                    sx={{
                      ml: 1,
                      height: 20,
                      backgroundColor: theme.palette.grey[300],
                      color: theme.palette.text.primary,
                      fontSize: "0.75rem",
                    }}
                  />
                )}
              </ToggleButton>

              <ToggleButton
                value={true}
                sx={{
                  flex: 1,
                  py: 1.5,
                  textTransform: "none",
                  fontWeight: 600,
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: isLido
                    ? theme.palette.primary.main
                    : "transparent",
                  backgroundColor: theme.palette.action.hover,
                  color: isLido ? "white" : theme.palette.text.secondary,
               
                }}
              >
                <NotificationsNoneIcon sx={{ mr: 1, fontSize: 20 }} />
                Lidas
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>

          {/* Conteúdo */}
          <Box sx={{ p: 3 }}>
            {isLoadingNotLida || isLoadingNotNaoLida ? (
              <Box>
                {[...Array(3)].map((_, index) => (
                  <Box key={index} sx={{ mb: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                      <Skeleton variant="circular" width={40} height={40} />
                      <Skeleton width="60%" height={20} sx={{ ml: 2 }} />
                    </Box>
                    <Skeleton
                      variant="rectangular"
                      width="100%"
                      height={60}
                      sx={{ borderRadius: 1 }}
                    />
                    <Skeleton width="40%" height={16} sx={{ mt: 1 }} />
                  </Box>
                ))}
              </Box>
            ) : (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 3,
                  }}
                >
                  <Typography variant="body1" color="text.secondary">
                    {notificacoes?.length || 0} notificação
                    {notificacoes?.length !== 1 ? "s" : ""}{" "}
                    {isLido ? "lida" : "não lida"}
                    {notificacoes?.length !== 1 ? "s" : ""}
                  </Typography>

                  {!isLido && notificacoes && notificacoes.length > 0 && (
                    <Button
                      size="medium"
                      onClick={setTodasComoLida}
                      variant="outlined"
                      startIcon={<CircleNotificationsIcon />}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                      }}
                    >
                      Marcar todas como lidas
                    </Button>
                  )}
                </Box>

                {notificacoes && notificacoes.length > 0 ? (
                  <List sx={{ width: "100%", p: 0 }}>
                    {notificacoes.map((notificacao, index) => (
                      <Card
                        key={index}
                        onClick={() => handleMarkAsRead(notificacao)}
                        sx={{
                          mb: 2,
                          borderRadius: 2,
                          boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                          border: `1px solid ${theme.palette.divider}`,
                          transition: "all 0.2s ease",
                          cursor: !isLido ? "pointer" : "default",
                          "&:hover": {
                            boxShadow: !isLido
                              ? "0 4px 12px rgba(0,0,0,0.08)"
                              : "0 2px 8px rgba(0,0,0,0.04)",
                            transform: !isLido ? "translateY(-2px)" : "none",
                            borderColor: theme.palette.primary.main,
                          },
                        }}
                      >
                        <ListItem alignItems="flex-start" sx={{ p: 2.5 }}>
                          <ListItemAvatar>
                            <Avatar
                              sx={{
                                backgroundColor: !isLido
                                  ? theme.palette.primary.main
                                  : theme.palette.grey[300],
                                color: "white",
                              }}
                            >
                              <CircleNotificationsIcon />
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <Typography
                                variant="subtitle1"
                                fontWeight="600"
                                color={"text.secondary"}
                                sx={{ mb: 0.5 }}
                              >
                                {notificacao.titulo}
                              </Typography>
                            }
                            secondary={
                              <>
                                <Typography
                                  variant="body2"
                                  color={
                                    !isLido ? "text.primary" : "text.secondary"
                                  }
                                  sx={{ mb: 1 }}
                                >
                                  {notificacao.texto}
                                </Typography>

                                <Chip
                                  icon={
                                    <CircleNotificationsIcon
                                      sx={{ fontSize: 14 }}
                                    />
                                  }
                                  label={formatDistanceToNow(
                                    new Date(notificacao.dataCadastro),
                                    {
                                      locale: ptBR,
                                      addSuffix: true,
                                    }
                                  )}
                                  size="small"
                                  variant="outlined"
                                  sx={{
                                    fontSize: "0.75rem",
                                    backgroundColor: "transparent",
                                    color: !isLido
                                      ? theme.palette.primary.main
                                      : theme.palette.text.secondary,
                                    borderColor: !isLido
                                      ? theme.palette.primary.main
                                      : theme.palette.grey[300],
                                  }}
                                />
                              </>
                            }
                          />
                        </ListItem>
                      </Card>
                    ))}
                  </List>
                ) : (
                  <Box
                    sx={{
                      textAlign: "center",
                      py: 6,
                      color: theme.palette.text.secondary,
                    }}
                  >
                    <NotificationsNoneIcon
                      sx={{ fontSize: 48, opacity: 0.5, mb: 2 }}
                    />
                    <Typography variant="h6" gutterBottom>
                      Nenhuma notificação
                    </Typography>
                    <Typography variant="body2">
                      {isLido
                        ? "Você não tem notificações lidas no momento"
                        : "Uhuul! Você está em dia com todas as notificações"}
                    </Typography>
                  </Box>
                )}
              </>
            )}

            {(hasNextPageLidas || hasNextPageNaoLidas) && (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                {isLoadingNotLida || isLoadingNotNaoLida || isLoading ? (
                  <Skeleton
                    width={160}
                    height={40}
                    animation="wave"
                    sx={{ borderRadius: 2 }}
                  />
                ) : (
                  <Button
                    onClick={handlerCarregarMais}
                    variant="outlined"
                    sx={{
                      borderRadius: 2,
                      textTransform: "none",
                      fontWeight: 600,
                      px: 3,
                    }}
                  >
                    Carregar mais notificações
                  </Button>
                )}
              </Box>
            )}
          </Box>
        </Card>
      </Box>
    </MenuDashboard>
  );
}
